import type { FC } from "react";

import { CaseSettings } from "../../caseSettings";

/**
 * "Case Settings" open in the center pane: biographical, employer and
 * data-management settings for the case, in a workspace tab.
 */
export const SettingsPane: FC = () => (
  <div className="h-full min-h-0 w-full overflow-hidden bg-background">
    <CaseSettings />
  </div>
);
